<mobi-breadcrumb />
<div class="gdover-hero is-background mobi-ui-padding-y-lg mobi-ui-margin-t-md">
  <div class="view-enter-animation mobi-ui-margin-b-xxl smMax:!mb-0">
    <div class="mobi-ui-grid is-centered mobi-ui-margin-y-md">
      <div>
        @if (entity().title) {
          <h1
            class="mobi-ui-font-h1 text-align-center"
            [class]="{ '!pb-2': entity().subtitle }"
          >
            {{ entity().title }}
          </h1>
        }
        @if (entity().subtitle) {
          <span
            class="mobi-ui-font-h4 mobi-ui-font-bold mobi-ui-font-realist mobi-ui-ink-black text-align-center mobi-ui-padding-t-xxs"
            [class]="{
              'mobi-ui-margin-b-sm': entity().lead,
            }"
          >
            {{ entity().subtitle }}
          </span>
        }
      </div>
    </div>
  </div>
  <div class="view-enter-animation">
    <div class="mobi-ui-grid mobi-ui-ink-blue mobi-ui-margin-y-md">
      @if (entity().promotedArticleLarge && breakpoint.mdAndLarger()) {
        <div class="mobi-ui-col-1/1 md:mobi-ui-col-1/2 !my-0 md:!p-0">
          <a
            [betterRouterLink]="entity().promotedArticleLarge.url | extractUrl"
            class="flex flex-col justify-between h-full text-black mobi-ui-col-1/1 md:mobi-ui-col-7/8 !m-0"
          >
            <div>
              @if (entity().promotedArticleLarge.teaserImage) {
                @defer (hydrate never) {
                  <mobi-media
                    [entity]="entity().promotedArticleLarge.teaserImage"
                    responsiveStyle="teaser_big"
                    [lazy]="false"
                  />
                }
              }
              <h4 class="mobi-ui-font-h3 mobi-ui-text-inked !pb-0 mobi-ui-padding-t-sm">
                {{ entity().promotedArticleLarge.teaserTitle }}
              </h4>
              @if (entity().promotedArticleLarge.teaserText) {
                <mobi-text
                  class="mobi-ui-font-size-300"
                  [data]="
                    entity().promotedArticleLarge.teaserText ?? '' | stripHtml: [] : true
                  "
                />
              }
              @if (
                entity().promotedArticleLarge?.upvotes &&
                (entity().promotedArticleLarge?.upvotes ?? 0) > 0
              ) {
                <mobi-rating-counter
                  class="mobi-ui-margin-t-sm"
                  [count]="entity().promotedArticleLarge?.upvotes ?? 0"
                />
              }
              <!-- ToDo: Make sure display is ok when merging feature/shwcs-1304 -->
              <div class="flex items-center gap-x-[18px]">
                <mobi-is-new
                  class="mobi-ui-margin-t-md smMax:!mt-5"
                  [date]="entity().promotedArticleLarge.created"
                />
              </div>
            </div>
          </a>
        </div>
      }
      <div class="self-stretch mobi-ui-col-1/1 md:mobi-ui-col-1/2 !my-0 md:!p-0">
        @if (
          entity().promotedArticlesSmall &&
          (entity().promotedArticlesSmall?.length ?? 0) > 0 &&
          breakpoint.mdAndLarger()
        ) {
          <mobi-guide-list
            class="flex flex-col justify-between h-full"
            [guides]="entity().promotedArticlesSmall!"
          ></mobi-guide-list>
        }
        @if (mobileArticles() && !breakpoint.mdAndLarger()) {
          <mobi-guide-list
            class="flex flex-col justify-between h-full"
            [guides]="mobileArticles()"
          />
        }
      </div>
    </div>
  </div>
</div>
<div class="page-content view-enter-animation">
  <mobi-content-section class="mobi-ui-ink-blue" [id]="'gdover-view'" [content]="content">
    <ng-template #content>
      @defer (hydrate on idle) {
        <mobi-guide-view
          [groupFilter]="['field_guide_gcat']"
          [viewId]="entity().viewRef?.view?.id || 'guide'"
          [display]="entity().viewRef?.view?.display || 'block_1'"
          [title]="
            'guide_overview_view_title'
              | texts: { context: 'frontend', default: 'Ratgeber' }
          "
        />
      }
    </ng-template>
  </mobi-content-section>
</div>
